/** API parça listesini fotoğraf üzeri hotspot ile birleştirir (x,y,w,h yüzde). */

export const ARAC_GORSEL = {
    url: `${process.env.PUBLIC_URL || ""}/dk-gelismis/arac-ustten.svg`,
    aspectRatio: "1011 / 470",
    onYon: "sag",
    kaynak: "Wikimedia Commons · Openclipart (CC BY-SA)",
};

const FALLBACK = [
    { id: "on_tampon", etiket: "Ön Tampon", x: 82, y: 32, w: 16, h: 36, varsayilan_islem: "onarim" },
    { id: "on_kaput", etiket: "Ön Kaput", x: 66, y: 26, w: 16, h: 48, varsayilan_islem: "boya" },
    { id: "on_cam", etiket: "Ön Cam", x: 58, y: 30, w: 10, h: 40, varsayilan_islem: "degisim" },
    { id: "sol_on_far", etiket: "Sol Ön Far", x: 74, y: 6, w: 10, h: 12, varsayilan_islem: "degisim" },
    { id: "sag_on_far", etiket: "Sağ Ön Far", x: 74, y: 82, w: 10, h: 12, varsayilan_islem: "degisim" },
    { id: "sol_on_camurluk", etiket: "Sol Ön Çamurluk", x: 52, y: 4, w: 22, h: 14, varsayilan_islem: "boya" },
    { id: "sag_on_camurluk", etiket: "Sağ Ön Çamurluk", x: 52, y: 82, w: 22, h: 14, varsayilan_islem: "boya" },
    { id: "sol_ayna", etiket: "Sol Ayna", x: 40, y: 20, w: 6, h: 8, varsayilan_islem: "degisim" },
    { id: "sag_ayna", etiket: "Sağ Ayna", x: 40, y: 72, w: 6, h: 8, varsayilan_islem: "degisim" },
    { id: "sol_on_kapi", etiket: "Sol Ön Kapı", x: 44, y: 16, w: 18, h: 18, varsayilan_islem: "boya" },
    { id: "sag_on_kapi", etiket: "Sağ Ön Kapı", x: 44, y: 66, w: 18, h: 18, varsayilan_islem: "boya" },
    { id: "tavan", etiket: "Tavan", x: 30, y: 28, w: 38, h: 44, varsayilan_islem: "boya" },
    { id: "motor_kaputu_alt", etiket: "Motor Bölmesi", x: 62, y: 34, w: 12, h: 28, varsayilan_islem: "onarim" },
    { id: "sol_arka_kapi", etiket: "Sol Arka Kapı", x: 26, y: 16, w: 18, h: 18, varsayilan_islem: "boya" },
    { id: "sag_arka_kapi", etiket: "Sağ Arka Kapı", x: 26, y: 66, w: 18, h: 18, varsayilan_islem: "boya" },
    { id: "sase_marspiyel", etiket: "Şase / Marşpiyel", x: 34, y: 44, w: 14, h: 12, varsayilan_islem: "onarim" },
    { id: "sol_arka_camurluk", etiket: "Sol Arka Çamurluk", x: 12, y: 4, w: 20, h: 14, varsayilan_islem: "boya" },
    { id: "sag_arka_camurluk", etiket: "Sağ Arka Çamurluk", x: 12, y: 82, w: 20, h: 14, varsayilan_islem: "boya" },
    { id: "bagaj_kapagi", etiket: "Bagaj Kapağı", x: 4, y: 26, w: 16, h: 48, varsayilan_islem: "boya" },
    { id: "arka_tampon", etiket: "Arka Tampon", x: 0, y: 32, w: 8, h: 36, varsayilan_islem: "onarim" },
];

export function ensureAllZones(apiZones) {
    const byId = new Map((apiZones || []).map((z) => [z.id, { ...z }]));
    for (const f of FALLBACK) {
        if (!byId.has(f.id)) byId.set(f.id, { ...f });
        else {
            const cur = byId.get(f.id);
            byId.set(f.id, {
                ...f,
                ...cur,
                x: cur.x ?? f.x,
                y: cur.y ?? f.y,
                w: cur.w ?? f.w,
                h: cur.h ?? f.h,
            });
        }
    }
    return [...byId.values()];
}

export function gorselFromDiagram(diagram) {
    const g = diagram?.gorsel;
    if (!g?.url) return ARAC_GORSEL;
    const base = process.env.PUBLIC_URL || "";
    const url = g.url.startsWith("http") ? g.url : `${base}${g.url}`;
    return { ...ARAC_GORSEL, ...g, url };
}
